import React from 'react';
import { CheckCircle, Users, Award } from 'lucide-react';

const WhySection = () => {
  const reasons = [
    {
      icon: <Award className="h-6 w-6 sm:h-8 sm:w-8 text-blue-600" />,
      title: "Why CareerLift?",
      description: "CareerLift is Australia's most proven Job-Ready Program, with 100s of student success stories, a unique hands-on lab, and recognition from higher education providers."
    },
    {
      icon: <Users className="h-6 w-6 sm:h-8 sm:w-8 text-green-600" />,
      title: "Who Can Join CareerLift?",
      description: "If you are an IT student, graduate, or career changer looking to start your first IT role, CareerLift's Job-Ready Program provides hands-on training, mentorship, career guidance, and ongoing support."
    },
    {
      icon: <CheckCircle className="h-6 w-6 sm:h-8 sm:w-8 text-yellow-600" />,
      title: "How Does CareerLift Help?",
      description: "CareerLift provides hands-on labs, real projects, mentorship, and career support — guiding students from zero level to landing their first IT job with confidence."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header with Image */}
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Why Choose CareerLift?
            </h2>
            <p className="text-xl text-gray-600 font-light leading-relaxed">
              We're not just another training provider. We're your partner in career transformation, 
              founded by industry experts who understand what it takes to succeed in tech.
            </p>
          </div>
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1758691737538-220c1902b1ca?w=800&q=85" 
              alt="Success celebration in modern office"
              className="rounded-2xl shadow-2xl hover-lift"
            />
          </div>
        </div>

        {/* Reasons Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="text-center p-8 border border-gray-200 rounded-xl hover:shadow-xl transition-all duration-300 hover:-translate-y-2 bg-white group"
            >
              <div className="inline-flex p-4 bg-blue-50 rounded-xl mb-6 group-hover:bg-blue-100 transition-colors">
                {reason.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{reason.title}</h3>
              <p className="text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;